import { prop } from 'ramda';

export const GET_SELECTED_FILTERS = 'getSelectedFilters';
export const GET_TOPICS = 'getTopics';
export const GET_SELECTED_TOPIC = 'getSelectedTopic';
export const GET_SELECTED_SUBTOPIC = 'getSelectedSubtopic';
export const GET_DATA = 'getData';
export const GET_YEAR_FILTER = 'getYearFilter';
export const GET_LOADING = 'getLoading';

const getSelectedFilters = prop('selectedFilters');
const getTopics = prop('topics');
const getSelectedTopic = prop('selectedTopic');
const getSelectedSubtopic = prop('selectedSubtopic');
const getData = prop('data');
const getYearFilter = prop('yearFilter');
const getLoading = prop('loading');

export default {
  [GET_SELECTED_FILTERS]: getSelectedFilters,
  [GET_TOPICS]: getTopics,
  [GET_SELECTED_TOPIC]: getSelectedTopic,
  [GET_SELECTED_SUBTOPIC]: getSelectedSubtopic,
  [GET_DATA]: getData,
  [GET_YEAR_FILTER]: getYearFilter,
  [GET_LOADING]: getLoading,
};
